import { useState, useEffect } from 'react'

const BadgeCheckIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#f79552"
    stroke="#fff"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
)

const USPBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const uspItems = [
    '60 seconds to make your claim',
    <>
      ON AVERAGE £2,086
      <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>1</sup> PER
      HOUSEHOLD
    </>,
    'AI powered for faster processing',
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % uspItems.length)
    }, 2000)

    return () => clearInterval(interval)
  }, [uspItems.length])

  return (
    <section
      className="sticky top-[60px] z-40 flex w-full items-center py-2 lg:top-[80px]"
      style={{ backgroundColor: 'oklch(0.2205 0.0376 194.77)' }}
    >
      <div className="mx-auto w-full max-w-7xl px-4">
        {/* Mobile & Tablet Carousel */}
        <div className="flex min-h-[44px] items-center justify-center lg:hidden">
          <div className="flex items-center">
            <BadgeCheckIcon className="mr-1.5 h-4 w-4 flex-shrink-0 sm:h-5 sm:w-5" />
            <span
              className="font-raleway-numbers text-base font-bold whitespace-nowrap text-white uppercase drop-shadow-lg transition-opacity duration-300 sm:text-lg"
              style={{ textShadow: 'rgba(0, 0, 0, 0.36) 0px 2px 3px' }}
            >
              {uspItems[currentIndex]}
            </span>
          </div>
        </div>

        {/* Large Desktop Horizontal Layout */}
        <div className="hidden flex-row items-center justify-center gap-8 lg:flex lg:gap-12 xl:gap-16">
          <div className="flex min-h-[44px] items-center">
            <BadgeCheckIcon className="mr-1.5 h-6 w-6 flex-shrink-0" />
            <span
              className="font-raleway-numbers text-base font-bold whitespace-nowrap text-white uppercase drop-shadow-lg xl:text-lg"
              style={{ textShadow: 'rgba(0, 0, 0, 0.36) 0px 2px 3px' }}
            >
              60 seconds to make your claim
            </span>
          </div>
          <div className="flex min-h-[44px] items-center">
            <BadgeCheckIcon className="mr-1.5 h-6 w-6 flex-shrink-0" />
            <span
              className="font-raleway-numbers text-base font-bold whitespace-nowrap text-white uppercase drop-shadow-lg xl:text-lg"
              style={{ textShadow: 'rgba(0, 0, 0, 0.36) 0px 2px 3px' }}
            >
              On average £2,086
              <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>
                1
              </sup>{' '}
              per household
            </span>
          </div>
          <div className="flex min-h-[44px] items-center">
            <BadgeCheckIcon className="mr-1.5 h-6 w-6 flex-shrink-0" />
            <span
              className="text-base font-bold whitespace-nowrap text-white uppercase drop-shadow-lg xl:text-lg"
              style={{ textShadow: 'rgba(0, 0, 0, 0.36) 0px 2px 3px' }}
            >
              AI powered for faster processing
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default USPBanner
